import type {DesignSelectorTab} from '@Components/design-selector/design-selector.types';

export const SELECTION_SUMMARY_SEPARATOR = '·';

export const TOP_TAB_UNPADDED_CLASSES = 'spacing-p-l-0 spacing-p-r-0';

export interface DesignSelectorTabSwitcherProps {
  designSelectorTab: DesignSelectorTab;
  onTabSelected: (newTab: DesignSelectorTab) => void;
  isMobile: boolean;
  hideTabContainer?: boolean;
  tabsId: string;
  selectedDesignCount?: number;
  onDeselectAll?: () => void;
}
